import { ARENA_H, ARENA_W, type Cover, type TeamId, type Wardstone } from "../sim/types";
import type { Vec } from "../sim/vec";

export const ARENA = { w: ARENA_W, h: ARENA_H, name: "Ashen Court" };

export interface CoverSpec {
  x: number;
  y: number;
  w: number;
  h: number;
  hp: number;
}

export const COVER_LAYOUT: CoverSpec[] = [
  { x: 8.6, y: 3.6, w: 2.4, h: 1.15, hp: 8 },
  { x: 3.6, y: 5.6, w: 1.2, h: 2.6, hp: 9 },
  { x: 17.0, y: 3.6, w: 2.4, h: 1.15, hp: 8 },
  { x: 23.2, y: 5.6, w: 1.2, h: 2.6, hp: 9 },
  { x: 8.6, y: 13.2, w: 2.4, h: 1.15, hp: 8 },
  { x: 3.6, y: 9.8, w: 1.2, h: 2.6, hp: 9 },
  { x: 17.0, y: 13.2, w: 2.4, h: 1.15, hp: 8 },
  { x: 23.2, y: 9.8, w: 1.2, h: 2.6, hp: 9 },
  { x: 12.2, y: 5.8, w: 1.15, h: 1.15, hp: 7 },
  { x: 14.65, y: 5.8, w: 1.15, h: 1.15, hp: 7 },
  { x: 12.2, y: 11.05, w: 1.15, h: 1.15, hp: 7 },
  { x: 14.65, y: 11.05, w: 1.15, h: 1.15, hp: 7 },
  { x: 10.4, y: 8.45, w: 0.85, h: 1.1, hp: 6 },
  { x: 16.75, y: 8.45, w: 0.85, h: 1.1, hp: 6 },
];

export interface StoneSpec {
  name: string;
  x: number;
  y: number;
  radius: number;
}

export const STONE_LAYOUT: StoneSpec[] = [
  { name: "West", x: 6.4, y: 9, radius: 1.7 },
  { name: "Heart", x: 14, y: 9, radius: 1.7 },
  { name: "East", x: 21.6, y: 9, radius: 1.7 },
];

export const SPAWNS: Record<TeamId, Vec[]> = {
  0: [
    { x: 2.4, y: 7.2 },
    { x: 2.4, y: 9.0 },
    { x: 2.4, y: 10.8 },
  ],
  1: [
    { x: 25.6, y: 7.2 },
    { x: 25.6, y: 9.0 },
    { x: 25.6, y: 10.8 },
  ],
};

export function makeCover(nextId: () => number): Cover[] {
  return COVER_LAYOUT.map((c) => ({
    id: nextId(),
    x: c.x,
    y: c.y,
    w: c.w,
    h: c.h,
    hp: c.hp,
    maxHp: c.hp,
    destroyed: false,
  }));
}

export function makeStones(nextId: () => number): Wardstone[] {
  return STONE_LAYOUT.map((s) => ({
    id: nextId(),
    name: s.name,
    pos: { x: s.x, y: s.y },
    radius: s.radius,
    owner: null,
    progress: 0,
    capturing: null,
  }));
}
